import { api } from "../../lib";

export interface TaskSummary {
  id: string;
  name: string;
  slug: string;
}

export interface RoleTasksResponse {
  roleId: string;
  roleName: string;
  tasks: TaskSummary[];
}

export interface RoleTaskEntry {
  id: string;
  roleId: string;
  roleName: string;
  taskId: string;
  taskName: string;
  taskSlug: string;
}

export interface AllRoleTasksResponse {
  roleTasks: RoleTaskEntry[];
}

export const roleTasksService = {
  getAll: async (): Promise<AllRoleTasksResponse> => {
    return api.get<AllRoleTasksResponse>("/admin/role-tasks");
  },

  getByRole: async (roleId: string): Promise<RoleTasksResponse> => {
    return api.get<RoleTasksResponse>(`/admin/roles/${roleId}/tasks`);
  },

  setForRole: async (
    roleId: string,
    taskIds: string[]
  ): Promise<RoleTasksResponse> => {
    return api.put<RoleTasksResponse>(`/admin/roles/${roleId}/tasks`, {
      taskIds,
    });
  },
};
